import ComingSoon from "components/ComingSoon";
import React from "react";

function Analytics() {
  return <ComingSoon />;
}

export default Analytics;
